<template>
  <div>


<!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    查詢訂單
    <a role="button" class="btn btn-primary" @click="QueryStatus('payed')">已付款</a>
    <a role="button" class="btn btn-primary" @click="QueryStatus('finish')">已完成</a>
    <a role="button" class="btn btn-primary" @click="QueryStatus('cancel')">已取消</a>

    匯出
    <a role="button" class="btn btn-info" onclick="ExportToExcel()">匯出Excel</a>

    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>功能</th>
        <th>訂單編號</th>
        <th>交易時間</th>
        <th>收據郵寄</th>
        <th>付款結果</th>
        <th>付款方式</th>
        <th>緣金總計</th>
        <th>訂單狀態</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="100px">
          <a role="button" class="btn btn-primary" href="#" @click="gotoDetail(item.id)">名單</a>

<!--          <span v-if="item.status==='expired'">-->
<!--            <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>-->
<!--          </span>-->
        </td>
        <td width="200px">
          {{item.orderNo}}
        </td>
        <td width="200px">
          {{item.orderDt | fmtDateUTC}}
        </td>
        <td width="220px">
          {{item.receiptGetWay}}
        </td>
        <td width="120px">
          {{item.payStatus}}
        </td>
        <td width="100px">
          {{item.payWay}}
        </td>
        <td width="120px">
          {{item.totalPrice}}
        </td>
        <td>
          <div v-if="item.payStatusCode==='payed'">
              已付款
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'finish')">改為已完成</a>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'cancel')">改為取消</a>
          </div>
          <div v-else-if="item.payStatusCode==='finish'">
            已完成
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'payed')">改為未完成(已付款)</a>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'cancel')">改為取消</a>
          </div>
          <div v-else-if="item.payStatusCode==='cancel'">
            已取消
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'finish')">改為已完成</a>
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'payed')">改為未完成(已付款)</a>
          </div>
          <div v-else>

          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";

export default {
  components: {MyCkEditor},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
      queryStatus:"payed",
    };
  },
  methods: {
    Export(){

    },
    QueryStatus(status){
      this.queryStatus=status;
      this.loadData();
    },
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGodsec.api_Admin_ProductOrder_Query(this.queryStatus).then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    // submit(){
    //   debugger // eslint-disable-line
    //   apiFireGodsec.api_Admin_EventDefine_Save(this.datas).then((data)=>{
    //     console.log(data);
    //     alert('儲存成功')
    //   })
    // },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    gotoDetail(id){
      this.$router.push({ name: 'ProductOrderDetail', query: { id: id }})
    },
    // deleteDetail(id){
    //   //confirm delete
    //   if(confirm('確定要刪除嗎?')){
    //     apiFireGodsec.api_Admin_ProductOrder_Delete(id).then(()=>{
    //       alert('刪除成功')
    //       this.loadData();
    //     })
    //   }
    //
    // },
    changeStatus(id,status){
      apiFireGodsec.api_Admin_ProductOrder_ChangeStaus(id,status).then((data)=>{
        console.log(data);
        alert('儲存成功')
        this.loadData();
      })
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1200px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>
